/* ---------------------------------------------------------------
   CTA nooit dood.

   Vóór maatkeuze heeft de hoofd-koopknop de class .disabled (puur
   cosmetisch — geen HTML disabled-attribuut). De CSS maakt hem binnen
   .main-product weer klikbaar. Dit script vangt de klik in díe staat af:
   het voorkomt de form-submit, scrollt smooth naar de maat-grid en laat
   daar een korte navy ring opflammen.

   Zodra een maat gekozen is haalt de thema-JS (component-product-form.js)
   de class .disabled weg — dan doet dit script niets en loopt de normale
   add-to-cart-flow ongehinderd. Het add-to-cart-mechanisme zelf wordt
   niet aangeraakt.

   Delegatie in de capture-fase op de productpagina: onze check draait
   vóór eventuele andere click-listeners, en preventDefault() blokkeert
   alleen de implicit submit wanneer er nog geen maat is.
--- */
(function () {
  'use strict';

  var FLASH_MS = 1300;

  function flash(variants) {
    if (!variants) return;
    variants.classList.remove('pdp-size-flash');
    // reflow forceren zodat de animatie herstart bij snel opnieuw klikken
    void variants.offsetWidth;
    variants.classList.add('pdp-size-flash');
    window.setTimeout(function () {
      variants.classList.remove('pdp-size-flash');
    }, FLASH_MS);
  }

  function onCapturedClick(e) {
    var page = e.currentTarget;
    var btn = e.target.closest('[data-js-product-add-to-cart]');
    if (!btn || !page.contains(btn)) return;

    // Maat gekozen (class weg) → niets doen, normale add-to-cart loopt door.
    if (!btn.classList.contains('disabled')) return;

    // Geen maat gekozen → submit voorkomen en naar de maat-grid leiden.
    e.preventDefault();
    e.stopPropagation();

    var variants =
      page.querySelector('product-variants[data-main-product-page-variants]') ||
      page.querySelector('product-variants[data-main-product-variants]') ||
      page.querySelector('product-variants');
    if (!variants) return;

    variants.scrollIntoView({ behavior: 'smooth', block: 'center' });
    flash(variants);
  }

  function init() {
    document
      .querySelectorAll('[data-js-product-component]')
      .forEach(function (page) {
        if (page.dataset.chooseSizeCtaBound) return;
        page.dataset.chooseSizeCtaBound = '1';
        page.addEventListener('click', onCapturedClick, true);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
